












import { Component, Mixins, Prop, } from "vue-property-decorator";
import {
  IItem,
  AbstractItem,
  instanceOfIClickChainRequestable,
  instanceOfIClickHandleable,
} from "../../../../domain/document/items";
import { ModelEditableMixin } from "../../../system/mixins";
import { CommonDialogsAccessor, CommonEditorsAccessor } from "../CommonComponentsAccessor";
import { DocumentStructureEditableMixin } from "../mixins";
import DrawableObject from "../DrawableObject.vue";

@Component({
  components: {
    DrawableObject,
  }
})
export default class ClickChainAgent extends Mixins(ModelEditableMixin, DocumentStructureEditableMixin) {

  $refs!: {
    object: DrawableObject;
  };

  @Prop()
  dialogs: CommonDialogsAccessor;

  @Prop()
  editors: CommonEditorsAccessor;

  get clickChainedItem(): IItem {
    return this.items && this.clickChainedObjectPrivateId
      ? this.items[this.clickChainedObjectPrivateId]
      : null;
  }

  get clickChainedObjectPrivateId(): number {
    return this.lastFocusedItem && instanceOfIClickChainRequestable(this.lastFocusedItem)
      ? this.lastFocusedItem.clickChainedObjectPrivateId
      : null;
  }

  async chain(): Promise<void> {
    await this.$nextTick(); // lastFocusedItemが更新されるのを待つ
    if (instanceOfIClickHandleable(this.$refs.object)) {
      this.$refs.object.clicked();
    }
  }

  onSourceUpdated(item: AbstractItem): void {
    this.updateItem(item, this.itemSetId);
  }
}
